import { render, staticRenderFns } from "./TrainingItemStatisticCard.vue?vue&type=template&id=1970c610&"
import script from "./TrainingItemStatisticCard.vue?vue&type=script&lang=js&"
export * from "./TrainingItemStatisticCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports